'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { claimOverlay } from '@nerdwallet/compass/overlay-availability';
import { type ComponentProps, useEffect, useId, useState } from 'react';
import { CARDFINDER_OVERLAY_OWNER_PREFIX } from './constants';
type DialogRootProps = ComponentProps<typeof Dialog.Root>;

/**
 * Base UI Dialog.Root that claims Compass overlay-availability while open so
 * Survicate (via hideSurvicateWhenBusy) hides without permanently dismissing.
 */
export function DialogRoot(t0) {
  const $ = _c(20);
  let onOpenChange;
  let openProp;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      open: openProp,
      defaultOpen: t1,
      onOpenChange,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = onOpenChange;
    $[2] = openProp;
    $[3] = rest;
    $[4] = t1;
  } else {
    onOpenChange = $[1];
    openProp = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const defaultOpen = t1 === undefined ? false : t1;
  const ownerId = useId();
  const isControlled = openProp !== undefined;
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
  const open = isControlled ? Boolean(openProp) : uncontrolledOpen;
  let t2;
  let t3;
  if ($[5] !== open || $[6] !== ownerId) {
    t2 = () => {
      if (!open) {
        return;
      }
      return claimOverlay(`${CARDFINDER_OVERLAY_OWNER_PREFIX}${ownerId}`);
    };
    t3 = [open, ownerId];
    $[5] = open;
    $[6] = ownerId;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== defaultOpen || $[10] !== isControlled || $[11] !== openProp) {
    t4 = isControlled ? {
      open: openProp
    } : {
      defaultOpen
    };
    $[9] = defaultOpen;
    $[10] = isControlled;
    $[11] = openProp;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isControlled || $[14] !== onOpenChange) {
    t5 = (nextOpen, eventDetails) => {
      if (!isControlled) {
        setUncontrolledOpen(nextOpen);
      }
      onOpenChange?.(nextOpen, eventDetails);
    };
    $[13] = isControlled;
    $[14] = onOpenChange;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== rest || $[17] !== t4 || $[18] !== t5) {
    t6 = <Dialog.Root {...rest} {...t4} onOpenChange={t5} />;
    $[16] = rest;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}